import React from 'react';
import './Reviewone.css';

const Reviewone = ({ content }) => {
  const reviewCards = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M4.5 3.75a3 3 0 00-3 3v.75h21v-.75a3 3 0 00-3-3h-15z" />
          <path fillRule="evenodd" d="M22.5 9.75h-21v7.5a3 3 0 003 3h15a3 3 0 003-3v-7.5zm-18 3.75a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" clipRule="evenodd" />
        </svg>
      ),
      title: "Free Consultations That Put You First",
      description: "We offer a free consultation to help you find the best fit for your brand's content needs. Whether it's photography, videography, headshots, or social media content, we guide you from first brainstorm to final delivery—so you always know what's coming next."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z" clipRule="evenodd" />
        </svg>
      ),
      title: "Flexible Scheduling Built Around Your Business",
      description: "We work around your hours, offering on-location and in-studio shoots with minimal disruption to your day. As a veteran-owned and family-run business, we value your time—every project is rooted in strategy, storytelling, and clarity of communication."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.75 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM8.25 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.75 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM10.5 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM12.75 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14.25 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 13.5a.75.75 0 100-1.5.75.75 0 000 1.5z" />
          <path fillRule="evenodd" d="M6 2.25A2.25 2.25 0 003.75 4.5v1.875c0 1.036.84 1.875 1.875 1.875H9.75a1.5 1.5 0 011.5 1.5v1.5H12A2.25 2.25 0 0114.25 12v.75h1.875c1.036 0 1.875.84 1.875 1.875V16.5A2.25 2.25 0 0116.5 18.75h-1.5a1.5 1.5 0 01-1.5-1.5v-1.5H12a2.25 2.25 0 01-2.25-2.25v-.75H7.875c-1.036 0-1.875-.84-1.875-1.875V4.5A2.25 2.25 0 016 2.25zM4.5 6a1.5 1.5 0 00-1.5 1.5V18a1.5 1.5 0 001.5 1.5h12A1.5 1.5 0 0018 18V7.5a1.5 1.5 0 00-1.5-1.5H4.5z" clipRule="evenodd" />
        </svg>
      ),
      title: "Safe, Certified Aerial Photography & Drone Video",
      description: "As an FAA Part 107 licensed drone operator, we capture legal, safe, and stunning aerial footage. Every file is delivered in formats ready for websites, social media, print, and mobile, so you can post with confidence—no extra edits needed."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path fillRule="evenodd" d="M15.22 6.268a.75.75 0 01.968-.432l5.942 2.28a.75.75 0 01.431.97l-2.28 5.941a.75.75 0 11-1.4-.537l1.63-4.251-1.086.483a11.2 11.2 0 00-5.45 5.174.75.75 0 01-1.199.19L9 12.31l-6.22 6.22a.75.75 0 11-1.06-1.06l6.75-6.75a.75.75 0 011.06 0l3.606 3.605a12.694 12.694 0 015.68-4.973l1.086-.484-4.251-1.631a.75.75 0 01-.432-.97z" clipRule="evenodd" />
        </svg>
      ),
      title: "Content That Grows With You",
      description: "Need content on a regular basis? Our monthly content retainers lock in discounted pricing and priority scheduling, so you never fall behind. We're here for the long haul—building lasting partnerships with brands that care about quality and connection."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
        </svg>
      ),
      title: "Satisfaction, Guaranteed",
      description: "We stand by our work. If you're not fully satisfied, we'll re-edit or reschedule at no additional cost. Plus, we provide fast editing turnaround times and unlimited minor revisions—because your success is our priority."
    }
  ];

  return (
    <section className="review-section" aria-labelledby="review-heading">
      <div className="review-container">
        <div className="review-header">
          <h2 id="review-heading" className="review-heading">
            {content.title}
          </h2>
          <div className="heading-accent"></div>
          
          <p className="review-subheading">
            {content.subtitle}
          </p>
        </div>
        
        <div className="review-grid">
          {reviewCards.map((card, index) => (
            <div 
              key={index} 
              className="review-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="card-inner">
                <div className="review-icon-wrapper">
                  <div className="review-icon">
                    {card.icon}
                  </div>
                  <div className="icon-backdrop"></div>
                </div>
                
                <h3 className="review-title">{card.title}</h3>
                <p className="review-description">{card.description}</p>
                
                <div className="card-hover-effect"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviewone;
